import { Alert, Chip, Tooltip } from '@mui/material'
import type { GranularityGovernance } from './granularityGovernance'
import { coarseningSummary, coarseningMarkerLabel } from './coarsening'

/** Page-level prominent badge shown beside the granularity control when active. */
export function CoarseningBadge({ governance }: { governance: GranularityGovernance }) {
  if (!governance.isCoarsened) return null
  return (
    <Alert severity="warning" sx={{ py: 0, mt: 1 }}>
      {coarseningSummary(governance)}
    </Alert>
  )
}

/** Subtle per-tile marker for governed (timeline/ratio) tiles when active. */
export function CoarseningMarker({ governance }: { governance: GranularityGovernance }) {
  if (!governance.isCoarsened) return null
  return (
    <Tooltip title={coarseningSummary(governance)}>
      <Chip
        size="small"
        color="warning"
        variant="outlined"
        label={coarseningMarkerLabel(governance)}
        // tabIndex makes the Tooltip reachable by keyboard; aria-label gives screen
        // readers the full reason (the ⚠ glyph + colour alone are not accessible).
        tabIndex={0}
        aria-label={coarseningSummary(governance)}
      />
    </Tooltip>
  )
}
